import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretDown,
  faCaretUp,
  faMinus
} from '@fortawesome/free-solid-svg-icons';

import { priceFormatter } from '../model/utils/helper/formatter/numberFormatter';

export interface IndexNumberProps {
  showIcon?: boolean;
  value: number | string;
}

export const IndexNumber: FC<IndexNumberProps> = ({ value, showIcon }) => {
  const num = typeof value === 'number' ? value : parseFloat(value);

  const isGrow = num > 0,
    isSame = !num;

  value = num + '' === value + '' ? priceFormatter.format(num) : value;

  return (
    <span
      className={`text-${isGrow ? 'success' : isSame ? 'secondary' : 'danger'}`}
    >
      {showIcon && (
        <FontAwesomeIcon
          className="me-2"
          icon={isGrow ? faCaretUp : isSame ? faMinus : faCaretDown}
        />
      )}
      {value}
    </span>
  );
};
